import React from "react";
import { withRouter } from "react-router-dom";
const LoginSidebar = () => {
  return <React.Fragment></React.Fragment>;
};
export default withRouter(LoginSidebar);
